const id_sales_recap = {
    "": "rekap tagihan penjualan",
    add: "tambah rekap tagihan penjualan",
    detail: "detail rekap tagihan penjualan",

    label: {
        no_recap: "no rekap tagihan",
        inv_choose: "pilih invoice",
        inv_selected: "tagihan terpilih:",
    },

    message: {
        cancel_title: "Apakah anda yakin untuk membatalkan rekap tagihan ?",
        cancel_text: "Masukan alasan membatalkan rekap tagihan",
    },

    error: {
        create: "Gagal membuat rekap tagihan penjualan.",
        edit: "Gagal mengubah rekap tagihan penjualan.",

        cancel: "Gagal membatalkan rekap tagihan",
    },

    success: {
        create: "Berhasil membuat rekap tagihan penjualan.",
        edit: "Berhasil mengubah rekap tagihan penjualan.",

        cancel: "Berhasil membatalkan rekap tagihan",
    },
}

export default id_sales_recap;